import React, { useEffect, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { withFirebase } from '../../services';
import history from '../../common/history'
import { AuthUserContext } from '../../Context';
import { Loading } from '../Generic';

function DashboardLayout(props) {
    const { children, firebase } = props;
    const [user, setUser] = useState(null);

    useEffect(() => {
        if (user === null) {
            firebase.onAuthUserListener(
                (user) => {
                    if (user) {
                        setUser(user);
                    }
                },
                () => {
                    history.push("/login");
                }
            );}
    }, [user])

    return (
        <>
            {user ?
                <AuthUserContext.Provider value={user}>
                    <div className="wrapper">
                         <Header user={user}/>
                        {children}
                        <Footer />
                    </div>
                </AuthUserContext.Provider>
                :
                <Loading />
            }
        </>
    )
}

export default withFirebase(DashboardLayout);